export interface Review {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
  role: string;
}

export const reviews: Review[] = [
  {
    id: 'rev-1',
    name: '王建国',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20headshot%20portrait%20with%20warm%20lighting%20on%20neutral%20background%20clean%20minimalist%20style&width=80&height=80&seq=avatar-rev-1&orientation=squarish',
    rating: 5,
    content: '使用 17c.com 已经一年多了，平台的稳定性和内容质量都非常出色。特别是智能推荐功能，总能精准地推送我感兴趣的内容，大大提高了我的信息获取效率。',
    date: '2026-07-25',
    role: '资深用户',
  },
  {
    id: 'rev-2',
    name: '陈晓燕',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20headshot%20with%20warm%20lighting%20on%20clean%20neutral%20background%20minimalist%20style&width=80&height=80&seq=avatar-rev-2&orientation=squarish',
    rating: 5,
    content: '作为内容创作者，17c.com 的数据分析工具对我的帮助非常大。我可以清晰地看到每篇文章的表现数据，从而不断优化内容策略。强烈推荐给同行！',
    date: '2026-07-22',
    role: '内容创作者',
  },
  {
    id: 'rev-3',
    name: '张明远',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20headshot%20portrait%20with%20warm%20lighting%20on%20clean%20neutral%20background%20minimalist%20style%20slight%20smile&width=80&height=80&seq=avatar-rev-3&orientation=squarish',
    rating: 4,
    content: '客服响应速度很快，有一次遇到登录问题，提交工单后不到十分钟就收到了回复。界面设计也很简洁大方，用起来很舒服。希望未来能增加更多个性化选项。',
    date: '2026-07-20',
    role: '普通用户',
  },
  {
    id: 'rev-4',
    name: '李美玲',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20headshot%20portrait%20with%20warm%20lighting%20on%20clean%20neutral%20background%20minimalist%20style%20confident%20expression&width=80&height=80&seq=avatar-rev-4&orientation=squarish',
    rating: 5,
    content: '移动端的体验真的非常棒！通勤路上用手机浏览 17c.com 已经成为我的日常习惯。离线阅读功能在地铁里尤其好用。界面适配也很完美。',
    date: '2026-07-18',
    role: '移动端用户',
  },
  {
    id: 'rev-5',
    name: '刘伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20headshot%20portrait%20with%20warm%20lighting%20on%20clean%20neutral%20background%20minimalist%20style%20friendly%20look&width=80&height=80&seq=avatar-rev-5&orientation=squarish',
    rating: 5,
    content: 'v3.0 版本更新后，整个平台焕然一新。搜索功能的速度和准确度都有了质的飞跃，界面更加现代化了。能感受到团队在用心做产品。',
    date: '2026-07-15',
    role: '高级会员',
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '17c.com 是免费使用的吗？',
    answer: '是的，17c.com 提供功能丰富的免费版本，注册后即可使用核心功能。同时我们也提供高级会员服务，解锁更多专属权益。免费版和高级版的详细对比请参考会员权益页面。',
  },
  {
    id: 'faq-2',
    question: '如何注册 17c.com 账户？',
    answer: '点击官网右上角的"注册"按钮，使用手机号或邮箱即可快速注册。填写基本信息后，验证邮箱即可激活账户，整个过程不超过三分钟。',
  },
  {
    id: 'faq-3',
    question: '忘记密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的邮箱或手机号，系统会发送密码重置链接。按照邮件中的指引操作即可重新设置密码。',
  },
  {
    id: 'faq-4',
    question: '17c.com 的数据安全如何保障？',
    answer: '我们采用 TLS 1.3 加密传输、多层访问控制和定期第三方安全审计。我们郑重承诺：绝不将用户数据出售给第三方。详情请参阅安全与隐私页面。',
  },
  {
    id: 'faq-5',
    question: '可以在多个设备上同时使用 17c.com 吗？',
    answer: '当然可以。17c.com 支持跨平台数据实时同步，您可以在电脑、平板和手机之间无缝切换使用。所有浏览记录、收藏内容都会自动同步。',
  },
  {
    id: 'faq-6',
    question: '如何联系 17c.com 客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至 support@17c.com、访问"关于我们"页面提交在线表单、或在工作日 9:00-18:00 拨打客服热线。高级会员享受优先客服响应。',
  },
  {
    id: 'faq-7',
    question: '如何升级到高级会员？',
    answer: '登录后进入"我的账户"页面，点击"升级会员"，选择会员方案并完成支付即可。支持微信支付和支付宝，支付成功后权益立即生效。',
  },
  {
    id: 'faq-8',
    question: '17c.com 是否支持内容离线阅读？',
    answer: '支持。在 Wi-Fi 环境下，系统会自动缓存您常看的内容类型。您也可以手动将单篇文章保存到本地，在网络不可用时继续阅读。',
  },
];